export type AppLang = "zh-CN" | "en";

const EN_PREFIX = "/en";

const normalizePath = (pathname: string) => {
  if (pathname === EN_PREFIX) return "/";
  if (pathname.startsWith(`${EN_PREFIX}/`)) {
    return pathname.replace(EN_PREFIX, "") || "/";
  }
  return pathname || "/";
};

const detectLangFromPath = (pathname: string): AppLang => {
  if (pathname === EN_PREFIX || pathname.startsWith(`${EN_PREFIX}/`)) return "en";
  return "zh-CN";
};

const withLangPrefix = (pathname: string, lang: AppLang) => {
  const base = normalizePath(pathname);
  if (lang === "en") {
    return base === "/" ? EN_PREFIX : `${EN_PREFIX}${base}`;
  }
  return base;
};

export const getLangInfo = (pathname: string) => {
  const lang = detectLangFromPath(pathname);
  const normalizedPath = normalizePath(pathname);
  const basePath = lang === "en" ? EN_PREFIX : "";
  return { lang, normalizedPath, basePath };
};

export { withLangPrefix, normalizePath };
